/* eslint-disable */ // my eslint/prettier config from 'et-webclient' is currently incompatible, need to fix later
import React, { useState, useEffect } from 'react'
import { Table, Typography, Button, notification, Tooltip } from 'antd'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { useIntl, FormattedMessage } from 'react-intl'
import { ShoppingCart } from 'react-feather'
import axios, { AxiosResponse } from 'axios'
import moment from 'moment'

import { CourseAvailableForPurchasePreview, CourseCatalogResponse } from './types'
import { FlexRow } from '../FlexboxReusables/FlexItems'
import { apiUrl, baseCurrency } from '../../globals'
import { displayPrice } from '../GenerateInvoice/invoiceUtils'
import { InfoCircleOutlined } from '@ant-design/icons'

const CourseCatalog = () => {
  const intl = useIntl()
  const [courseCatalog, setCourseCatalog] = useState<CourseCatalogResponse>({
    minimumParticipantsForMassDiscount: 0,
    massDiscountPercentage: 0,
    coursePreviews: [],
    partnerName: null,
    partnerDiscountPercentage: null,
  })
  const [isPartner, setIsPartner] = useState(false)
  const [partnerName, setPartnerName] = useState('')
  const [partnerDiscountPercentage, setPartnerDiscountPercentage] = useState(0)

  useEffect(() => {
    fetchCourseCatalog()
  }, [])

  const fetchCourseCatalog = () => {
    axios
      .get(`${apiUrl}/courses/available-for-purchase`)
      .then((res: AxiosResponse<CourseCatalogResponse>) => {
        setCourseCatalog(res.data)

        if (res.data.partnerName) {
          setIsPartner(true)
          setPartnerName(res.data.partnerName)
          setPartnerDiscountPercentage(res.data.partnerDiscountPercentage || 0)
        }
      })
      .catch(() =>
        notification.error({
          message: intl.formatMessage({ id: 'notification.error' }),
          description: 'Beim Laden des Kurskatalogs ist ein Fehler aufgetreten.',
          placement: 'bottomRight',
        }),
      )
  }

  const columns = [
    {
      title: <FormattedMessage id='course.name' />,
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: <FormattedMessage id='course.description' />,
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: <FormattedMessage id='generic.preview' />,
      key: 'preview',
      render: (record: CourseAvailableForPurchasePreview) => (
        <Link to={`/course-catalog/${record.id}`}>
          <FormattedMessage id='generic.viewPreview' />
        </Link>
      ),
    },
    {
      title: <FormattedMessage id='generic.pricePerParticipant' />,
      key: 'purchasePrice',
      render: (record: CourseAvailableForPurchasePreview) => {
        const originalPrice = displayPrice(record.purchasePrice, baseCurrency)
        const discountedPrice = isPartner
          ? displayPrice(record.purchasePrice, baseCurrency, partnerDiscountPercentage)
          : null

        return (
          <div style={{ minWidth: 120 }}>
            {courseCatalog.partnerName ? (
              <FlexRow>
                <StrikeThroughText>{originalPrice}</StrikeThroughText>
                <Tooltip
                  title={`Als ET-Partner erhält ${courseCatalog.partnerName} ${partnerDiscountPercentage}% Rabatt.`}
                >
                  <InfoCircleOutlined style={{ marginLeft: '0.5em' }} />
                </Tooltip>
              </FlexRow>
            ) : (
              <>{originalPrice}</>
            )}
            {discountedPrice && <FlexRow>{discountedPrice}</FlexRow>}
          </div>
        )
      },
    },
    {
      title: <FormattedMessage id='generic.publishedAt' />,
      key: 'publishedAt',
      render: (record: CourseAvailableForPurchasePreview) => moment(record.publishedAt).format('DD.MM.YYYY'),
    },
    {
      title: 'Zertifikatsgültigkeit', // TODO: i18n
      key: 'examValidityMonths',
      dataIndex: 'examValidityMonths',
      render: (examValidityMonths?: number) => (examValidityMonths ? `${examValidityMonths} Monate` : 'unbegrenzt'),
    },
    {
      title: <FormattedMessage id='generic.buy' />,
      key: 'buy',
      render: (record: CourseAvailableForPurchasePreview) => (
        <Link
          to={`/buy-course-access/${record.id}`}
          state={{
            course: record,
            isPartner,
            partnerName,
            partnerDiscountPercentage,
          }}
        >
          <Button type='primary'>
            <FlexRow>
              <ShoppingCart style={{ marginRight: '0.5em' }} />
              <FormattedMessage id='generic.buy' />
            </FlexRow>
          </Button>
        </Link>
      ),
    },
  ]

  return (
    <PageContainer>
      <FlexRow margin='2em 0 0 0'>
        <Typography.Title level={2}>
          <FormattedMessage id='navigation.courseCatalog' />
        </Typography.Title>
      </FlexRow>
      <FlexRow>
        <Typography.Text>Alle Preise verstehen sich als Nettopreise</Typography.Text>
      </FlexRow>
      <FlexRow>
        <Typography.Text>
          {`Ab ${courseCatalog.minimumParticipantsForMassDiscount} Teilnehmern gibt es standardmäßig ${courseCatalog.massDiscountPercentage}% Rabatt.`}
        </Typography.Text>
      </FlexRow>
      <TableContainer>
        <Table
          dataSource={courseCatalog.coursePreviews}
          columns={columns}
          rowKey='id'
          loading={!courseCatalog.coursePreviews.length}
        />
      </TableContainer>
    </PageContainer>
  )
}

export default CourseCatalog

const PageContainer = styled.div`
  zoom: 1.1;
`

const TableContainer = styled.div`
  margin: 2em auto;
  max-width: 80%;
`

const StrikeThroughText = styled.div`
  text-decoration: line-through;
  color: grey;
`
